import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=b174212c&scoped=true"
import script from "./eventDetail.vue?vue&type=script&lang=js"
export * from "./eventDetail.vue?vue&type=script&lang=js"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=b174212c&prod&lang=css"
import style1 from "./eventDetail.vue?vue&type=style&index=1&id=b174212c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b174212c",
  null
  
)

export default component.exports